import { render, staticRenderFns } from "./ConfirmCompany.vue?vue&type=template&id=b8a4198a"
import script from "./ConfirmCompany.vue?vue&type=script&lang=js"
export * from "./ConfirmCompany.vue?vue&type=script&lang=js"
import style0 from "./ConfirmCompany.vue?vue&type=style&index=0&id=b8a4198a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports